// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import wixData from 'wix-data';

$w.onReady(function () {
	//TODO: write your page related code here...
});

// Filter by "Voucher ID"
function filterByID(search) {
	$w('#dataset1').setFilter(wixData.filter().contains("Voucher ID", search));
}

// Filter by "Customer Name"
function filterByCustomerName(search) {
	$w('#dataset1').setFilter(wixData.filter().contains("Customer Name", search));
}

// Filter by "Voucher From"
function filterByVoucherFrom(search) {
	$w('#dataset1').setFilter(wixData.filter().contains("Voucher From", search));
}

// Clear all search input fields button
export function clearFilterButton_click(event) {
	$w('#searchCustomerNameInput').value = "";
	$w('#searchVoucherFromInput').value = "";
	$w('#searchVoucherIDInput').value = "";
	filterByCustomerName($w('#searchVoucherFromInput').value);
}

// Search voucher table when clicking on the Search button
export function searchDBButton_click(event) {
	//filterByCustomerName($w('#searchCustomerNameInput').value);
	//let voucherID = parseInt($w('#searchVoucherIDInput'), 10);
	console.log($w('#searchVoucherIDInput').value);
	filterByID($w('#searchVoucherIDInput').value);

	/*
	// searchVoucherIDInput keypress
	export function searchVoucherIDInput_keyPress(event, $w) {
		filterByID($w('#searchVoucherIDInput').value);
	}

	// searchCustomerNameInput keypress
	export function searchCustomerNameInput_keyPress(event) {
		filterByCustomerName($w('#searchCustomerNameInput').value);
	}

	// searchVoucherFromInput keypress
	export function searchVoucherFromInput_keyPress(event) {
		filterByCustomerName($w('#searchVoucherFromInput').value);
	} */
}